import React from 'react'

import {
  BrowserRouter as Router, Routes, Route
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import Layout from './components/Layout.js';
import Home from './components/home.js';
import About from './components/tabs/about.js';
import Art from './components/tabs/art.js';
import Projects from './components/tabs/projects.js';
import Spaces from './components/tabs/spaces.js';

import EverydaySounds from './components/case_studies/everydaysounds.js';
import VRCooking from './components/case_studies/vrcooking.js';
import Vessel from './components/case_studies/vessel.js';
import BloombergConnects from './components/case_studies/bloombergconnects.js';
import AdsNYTGames from './components/case_studies/adsnytgames.js';
import ImageAttribution from './components/case_studies/imageattribution.js';

function App() {
  return (
    <HelmetProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route element={<Layout/>}>
            <Route path="/" element={<Home/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/art" element={<Art/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/spaces" element={<Spaces/>}/>

            <Route path="/everydaysounds" element={<EverydaySounds/>}/>
            <Route path="/vrcooking" element={<VRCooking/>}/>
            <Route path="/vessel" element={<Vessel/>}/>
            <Route path="/bloombergconnects" element={<BloombergConnects/>}/>
            <Route path="/adsnytgames" element={<AdsNYTGames/>}/>
            <Route path="/imageattribution" element={<ImageAttribution/>}/>

            <Route path="/*" element={<Home/>}/>
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}
  
export default App;
